import { SharedState } from '@trello/shared-state';

export const isBoardRenderedSharedState = new SharedState<boolean>(false);
